// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hk-0";